import React from 'react';
import get from 'lodash/get';
import ArrayHelper from 'foundation/array-helper';
import { LazyImage } from 'project/lazy-image';
import { CountryFlag, bemClasses } from 'project/country-flag';
import { playerSitecoreData } from 'components/live-player';
import { ScorePlayerCell } from 'components/scores';
import { getRoundById } from 'general/js/helpers';
import LeaderboardPlayerResult from '../../leaderboard/js/components/leaderboard-player-result';


const LeaderboardWidgetFavoriteNameContent = ({
    player,
    isPlayOff,
    liveScanner,
    stateFavoriteButton
}) => {
    const sitecoreData = player.sitecoreData || playerSitecoreData;
    const currentRound = player.currentRound;
    const foundRound = getRoundById(player.rounds, currentRound);
    const trimmedFirstName = sitecoreData.firstName === 'Sir Nick' ? 'N' : sitecoreData.firstName.charAt(0);
    const playerFirstName = stateFavoriteButton || isPlayOff ? sitecoreData.firstName : trimmedFirstName;
    const playerLastName = stateFavoriteButton || isPlayOff ? sitecoreData.lastName : sitecoreData.lastName + ',';
    //const scoringCourseRound = player.rounds[currentRound];
    const renderIndicators = () => {
        return foundRound.info.map((holePar, i) => {
            const playerPar = get(foundRound, `info[${i}].playerPar`) || null;
            return (
                <ScorePlayerCell
                    childCss='leaderboard-widget-favorite__cell-player-leaders-indicators-item'
                    key={holePar.holeId}
                    holePar={holePar.holePar}
                    playerPar={playerPar}
                />
            );
        });
    };
    const renderIndicatorsComponent = () => {
        const playOffRoundId = liveScanner.liveComponents.leaderboard !== undefined ? liveScanner.liveComponents.leaderboard.playoffRoundId : 401;
        if (!foundRound || ArrayHelper.isEmpty(foundRound.info)) return null;

        if (isPlayOff) {
            const playOffRound = getRoundById(player.rounds, playOffRoundId);

            return <LeaderboardPlayerResult playOffRound={playOffRound} />;
        }

        return (
            <div className="leaderboard-widget-favorite__cell-player-leaders-indicators-wrapper">
                <div className="leaderboard-widget-favorite__cell-player-leaders-current-round">
                    r{currentRound}
                </div>
                <div className="leaderboard-widget-favorite__cell-player-leaders-indicators-list">
                    {renderIndicators()}
                </div>
            </div>
        );
    };
    return (
        <div className={'leaderboard-widget-favorite__name-content'}>
            { !stateFavoriteButton &&
                <CountryFlag
                    childCss={'leaderboard-widget-favorite__country-flag'}
                    image={sitecoreData.countryFlagSrc}
                    bemList={[bemClasses.SMALL]}
                    title={sitecoreData.country}
                />
            }
            { (stateFavoriteButton || isPlayOff) && sitecoreData.cutoutSrc &&
                <div className="leaderboard-widget-favorite__cell-player-leaders-photo">
                    <LazyImage image={sitecoreData.cutoutSrc}/>
                </div>
            }
            { (stateFavoriteButton || isPlayOff) &&
                <div className="leaderboard-widget-favorite__indicators">
                    {renderIndicatorsComponent()}
                </div>
            }
            {
                sitecoreData.lastName &&
                <div className="leaderboard-widget-favorite__name-content-last-name">{playerLastName}</div>
            }
            {
                sitecoreData.firstName &&
                <div className="leaderboard-widget-favorite__name-content-first-name">{playerFirstName}</div>
            }
            {
                sitecoreData.isChampion &&
                <div className="leaderboard-widget-favorite__is-champion">
                    <svg className="leaderboard-widget-favorite__icon icon" width="24" height="26" focusable="false">
                        <use xlinkHref="#icon-symbol"></use>
                    </svg>
                </div>
            }
        </div>
    );
};

export default LeaderboardWidgetFavoriteNameContent;
